import * as React from 'react';
import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { UIComponentHandler, UIDataModel} from '../../../../toolkit/uicomponent';
import { Strings } from '../../../../../utils/resources/strings';
import { TimeSettingsComponentProps, TimeSettingsComponentState, TimeSettingsComponentHandler } from './timesettingscomponent';
import { TimeSettingsCSSStyle } from './timesettingscss';
import { RepeatCardSettingComponent } from '../repeatcardsetting/repeatcardsettingcomponent';
import { TimePickerComponent } from '../../../../toolkit/timepicker/timepicker';
import { TimeBasedSettingForAllCallersDtoImpl } from '../../../../../core/dto/timebasedsetting/timebasedsettingforallcallersdto';
import { DateTimePickerComponent } from '../../../../toolkit/datetimepicker/datetimepicker';
import * as moment from 'moment';
import { SelectComponent } from '../../../../toolkit/select/selectcomponent';
import { DropdownRowViewModelHandler, DropDownRowViewModelImpl } from '../../../../toolkit/dropdownlist/dropdownrow/dropdownviewmodel';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { DropDownDto, DropDownDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/dropdown/dropdowndto';
import { PopUpWrapperComponent } from '../../../popup/popupwrappercomponent';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../../toolkit/alert/alertcomponent';
import './time-settings-style.css';

export class TimeSettingsViewImpl extends UIComponentViewImpl<UIDataModel> implements DropdownRowViewModelHandler
{
    private selectTimeFromDateRef: any;
    private selectTimeToDateRef: any;
    private weeklyIntervalList: string[] = [];
    private selectFromDateTimeRef: any;
    private selectToDateTimeRef:any;
    private popUpComponent :PopUpWrapperComponent;

    private listViewModel: DropDownRowViewModelImpl;
    private selectGroupComponent: SelectComponent | null;
    // private repeatInterval: string;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
        
       this.listViewModel = new DropDownRowViewModelImpl(false, context, this);

    //    this.listViewModel.setListDatas(this.getListOfDropDown());
    }
    bindHandlers()
    {
        this.onSelected = this.onSelected.bind(this);
        this.onRepeatClick = this.onRepeatClick.bind(this);
        this.onRowSelected = this.onRowSelected.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);

    }
    
    draw(props: TimeSettingsComponentProps, state: TimeSettingsComponentState, cssStyle: TimeSettingsCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        this.weeklyIntervalList.length = 0;
        this.listViewModel.setListDatas(this.getDropDownList());
        return (
            <>
            {
                this.getWebView(props, state, cssStyle)
            }
            <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>

            </>
        );
    }


    getWebView(props: TimeSettingsComponentProps, state: TimeSettingsComponentState, cssStyle: TimeSettingsCSSStyle)
    {
        return (
            <div id="time-settings-main" style={cssStyle.getWrapperCSSStyle()}>
              
            <div id="time-settings-inner-wrapper">
                  <div id="time-settings-select-time">
                      <SelectComponent listEmptyErrorMsg={this.getUIProps().context.getResources().getString(Strings.no_time_type_avaliable)} ref={(item)=>{this.selectGroupComponent = item;}} listViewModel={this.listViewModel} placeholder={this.getUIProps().context.getResources().getString(Strings.select_time_type)} id={"#select_time_type"} value={state.callerSetting} isRequired={true}  context={this.getUIProps().context} emptyErrorMsg={this.getUIProps().context.getResources().getString(Strings.invalid_time_type)}/>
                  </div>

                   <div id="time-settings-dropdown-select">
                          {
                              state.callerSetting === props.context.getResources().getString(Strings.full_day)  && this.getFullDayCSS(cssStyle, state)
                          }
                      
                          {
                              state.callerSetting === props.context.getResources().getString(Strings.select_time)  && this.getSelectTimeCSS(cssStyle, state) 
                          }
                  
                          {
                              state.callerSetting === props.context.getResources().getString(Strings.select_date_time)  && this.getSelectDateTimeCSS(cssStyle, state)
                          }
                   </div>
                   <label id="time-settings-repeat-label" style={cssStyle.getRepeatLabelCSSStyle()}>
                          {this.getUIProps().context.getResources().getString(Strings.repeat)}
                  </label>
                  <div id="time-settings-repeat-data"> 
                       
                      {    
                      state.callerSetting === props.context.getResources().getString(Strings.select_date_time) && this.getRepeatCSS(cssStyle)
                      }
                      {    
                      state.callerSetting === props.context.getResources().getString(Strings.select_time) && this.getRepeatDayCSS(cssStyle)
                      }
                      {    
                      state.callerSetting === props.context.getResources().getString(Strings.full_day) && this.getRepeatDayCSS(cssStyle)
                      }
                  </div>
            </div> 

      </div>
        );
    }

    getIntervalListLength():number
    {
       return  this.weeklyIntervalList.length;
    }

    protected closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }

    showPopup(id:string,msg:string,type:AlertType):void
    {         
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);
    }
    getDropDownList():DropDownDto[]
    {
        let data1 = new DropDownDtoImpl();
        data1.setId(this.getContext().getResources().getString(Strings.full_day));
        data1.setTitle(this.getContext().getResources().getString(Strings.full_day));

        let data2 = new DropDownDtoImpl();
        data2.setId(this.getContext().getResources().getString(Strings.select_time));
        data2.setTitle(this.getContext().getResources().getString(Strings.select_time));

        let data3 = new DropDownDtoImpl();
        data3.setTitle(this.getContext().getResources().getString(Strings.select_date_time));
        data3.setId(this.getContext().getResources().getString(Strings.select_date_time));
        return [data1, data2, data3];

        
    }
    getAllCallerData(timeBasedSettingForAllCallersDto: TimeBasedSettingForAllCallersDtoImpl)
    {
        let state = (this.getUIState() as TimeSettingsComponentState);
        let timeSettingSelected = state.callerSetting;
        let repeatInterval = state.repeatInterval;

        console.log("-------: all callerdate: " + this.weeklyIntervalList);

        timeBasedSettingForAllCallersDto.setWeeklyDays(this.weeklyIntervalList);
        timeBasedSettingForAllCallersDto.setRepeatInterval(repeatInterval);
        timeBasedSettingForAllCallersDto.setTimeSettingSelected(timeSettingSelected);

        if(timeSettingSelected === this.getUIProps().context.getResources().getString(Strings.full_day))
        {
            timeBasedSettingForAllCallersDto.setStartTimestamp(this.getUIProps().context.getResources().getString(Strings.default_start_time));
            timeBasedSettingForAllCallersDto.setEndTimestamp(this.getUIProps().context.getResources().getString(Strings.default_end_time));
        }
        else if(timeSettingSelected === this.getUIProps().context.getResources().getString(Strings.select_time))
        {
            timeBasedSettingForAllCallersDto.setStartTimestamp(this.selectTimeFromDateRef.getData());
            timeBasedSettingForAllCallersDto.setEndTimestamp(this.selectTimeToDateRef.getData());
        }
        else
        {
            timeBasedSettingForAllCallersDto.setStartTimestamp(this.selectFromDateTimeRef.getData());
            timeBasedSettingForAllCallersDto.setEndTimestamp(this.selectToDateTimeRef.getData());    
        }
    }
  
    validate(): boolean
    {
        if(this.selectGroupComponent !== null && this.selectGroupComponent.validate())
        {
        let repeatInterval = (this.getUIState() as TimeSettingsComponentState).repeatInterval;
        let timeSettingSelected = (this.getUIState() as TimeSettingsComponentState).callerSetting;
        if(timeSettingSelected === this.getUIProps().context.getResources().getString(Strings.select_time))
        {
            if(this.selectTimeFromDateRef !== null && this.selectTimeToDateRef !== null)
            {
               //check the start date should not be greater then end time
               if(this.selectTimeFromDateRef.validate())
               {
                   if(this.selectTimeFromDateRef.getData() >= this.selectTimeToDateRef.getData())
                   {
                       this.showPopup("",this.getUIProps().context.getResources().getString(Strings.time_greater_than_or_equal),AlertType.WARN);
                    //    alert(this.getUIProps().context.getResources().getString(Strings.time_greater_than_or_equal));
                       return false;
                   }
                   return true;
               }
              
            }            
            else
            {
                return false;
            }
        }
        else if(timeSettingSelected === this.getUIProps().context.getResources().getString(Strings.select_date_time))
        {
            //check null conidtion for ref of startdatetime nd enddatetime
            if(this.selectFromDateTimeRef !== null && this.selectToDateTimeRef !== null )
           {
               if(repeatInterval === this.getUIProps().context.getResources().getString(Strings.none))
               {
                if(this.selectFromDateTimeRef.validate() && this.selectToDateTimeRef.validate()) 
                {
                    if(!this.validateDate(this.selectFromDateTimeRef.getData() ,this.selectToDateTimeRef.getData()))
                    {
                        console.log("from Date:",this.selectFromDateTimeRef.getData()+"to Date:"+this.selectToDateTimeRef.getData());
                        this.showPopup("",this.getUIProps().context.getResources().getString(Strings.time_greater_than_or_equal),AlertType.WARN);

                        // alert(this.getUIProps().context.getResources().getString(Strings.time_greater_than_or_equal));
                        return false;
                    }
                    return true;
                }
                else
                {
                    return false;
                }
            }
            else if(repeatInterval === this.getUIProps().context.getResources().getString(Strings.monthly))
            {
                //difference between end-date and start-date should not be more than 30.
               
                
                    if(this.selectFromDateTimeRef.validate() && this.selectToDateTimeRef.validate() ) 
                    {
                        if(!this.validateDate(this.selectFromDateTimeRef.getData() ,this.selectToDateTimeRef.getData()))
                        {
                            console.log("from Date:",this.selectFromDateTimeRef.getData()+"to Date:"+this.selectToDateTimeRef.getData());
                            this.showPopup("",this.getUIProps().context.getResources().getString(Strings.time_greater_than_or_equal),AlertType.WARN);
                    
                            // alert(this.getUIProps().context.getResources().getString(Strings.time_greater_than_or_equal));
                            return false;
                        }
                        else{
                            if(this.getEndDuration(this.selectFromDateTimeRef.getData(), this.selectToDateTimeRef.getData()) >= 30
                            || this.getStartDuration(this.selectFromDateTimeRef.getData(), this.selectToDateTimeRef.getData()) >= 30)
                            {
                                
                                this.showPopup("",this.getUIProps().context.getResources().getString(Strings.difference_more_than_30),AlertType.WARN);
        
                                // alert(this.getUIProps().context.getResources().getString(Strings.difference_more_than_30));
                                return false;
                            }
                            return true;
                        }
                       
                        
                    }

                
               
                   
                   
            }
               
               
            
            else if(repeatInterval === this.getUIProps().context.getResources().getString(Strings.yearly))
            {
                if(!this.validateDate(this.selectFromDateTimeRef.getData() ,this.selectToDateTimeRef.getData()))
                {
                    console.log("from Date:",this.selectFromDateTimeRef.getData()+"to Date:"+this.selectToDateTimeRef.getData());
                    this.showPopup("",this.getUIProps().context.getResources().getString(Strings.time_greater_than_or_equal),AlertType.WARN);

                    // alert(this.getUIProps().context.getResources().getString(Strings.time_greater_than_or_equal));
                    return false;
                }
                else
                {
                    if(this.getEndDuration(this.selectFromDateTimeRef.getData(), this.selectToDateTimeRef.getData()) >= 365
                    || this.getStartDuration(this.selectFromDateTimeRef.getData(), this.selectToDateTimeRef.getData()) >= 365)
                    {
                        
                        this.showPopup("",this.getUIProps().context.getResources().getString(Strings.difference_more_than_365),AlertType.WARN);
    
                        // alert(this.getUIProps().context.getResources().getString(Strings.difference_more_than_365));
                        return false;
                    }
                    return true;
                }
              
                //difference between end-date and start-date should not be more than 365.
                //follow my code ---to accept correct date
            }
           
            
            
          }
        }
        return true;
        }
        else
        {
            return false;
        }
    }

    validateDate(fromDate:string, toDate:string):boolean
    {
        let  startDate = moment(fromDate, 'DD-MM-YYYY HH:mm');
        let endDate = moment(toDate, 'DD-MM-YYYY HH:mm');
        console.log("-----tigervalidatestart: " + startDate);
        console.log("-----tigervalidateend: " + endDate);
        console.log("-----tigervalidateend: " + (startDate >= endDate));
        if(startDate >= endDate)
        {
            return false;
        }
        return true;
    }
    onRowSelected(dropDownDto: DropDownDto): void 
    {
        this.onSelected(true, dropDownDto.getTitle());
       this.selectGroupComponent !== null
        && this.selectGroupComponent.onOptionSelected(dropDownDto.getId(), dropDownDto.getTitle());
        
    }

    private getFullDayCSS(cssStyle: TimeSettingsCSSStyle, state: TimeSettingsComponentState)
    {
        return (
        <div id="time-settings-fullday-main">
            <div id="time-settings-fullday-calender" >
                <img src={this.getUIProps().context.getResources().getImage("calender.svg")}/>
            </div>
            <div id="time-settings-fullday-header">
              <label id="time-settings-header-title" style={cssStyle.getTimeHeaderCSSStyle()}>{this.getUIProps().context.getResources().getString(Strings.time)}</label><br/>
              <label id="time-settings-header-value" style={cssStyle.getTimeValueCSSStyle()}>{"24 hrs"}</label>
            </div>
          
        </div>
        );
    }

    private getRepeatDayCSS(cssStyle:TimeSettingsCSSStyle)
    {
        return(
               <>
                 <div id="time-settings-repeat-mode-days-web">
                     <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.sun)} onRepeatClick={this.onRepeatClick} title={this.getUIProps().context.getResources().getString(Strings.sunday)} isSelected={false} context={this.getContext()}/>
                     <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.mon)} onRepeatClick={this.onRepeatClick} title={this.getUIProps().context.getResources().getString(Strings.monday)} isSelected={false} context={this.getContext()}/>
                     <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.tue)} onRepeatClick={this.onRepeatClick} title={this.getUIProps().context.getResources().getString(Strings.tuesday)} isSelected={false} context={this.getContext()}/>
                     <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.wed)} onRepeatClick={this.onRepeatClick} title={this.getUIProps().context.getResources().getString(Strings.wednesday)} isSelected={false} context={this.getContext()}/>
                     <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.thu)} onRepeatClick={this.onRepeatClick} title={this.getUIProps().context.getResources().getString(Strings.thursday)} isSelected={false} context={this.getContext()}/>
                     <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.fri)} onRepeatClick={this.onRepeatClick} title={this.getUIProps().context.getResources().getString(Strings.friday)} isSelected={false} context={this.getContext()}/>
                     <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.sat)} onRepeatClick={this.onRepeatClick} title={this.getUIProps().context.getResources().getString(Strings.saturday)} isSelected={false} context={this.getContext()}/>

                </div>
                <div id="time-settings-repeat-mode-days-mobile">
                     <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.sun)} onRepeatClick={this.onRepeatClick} title={this.getUIProps().context.getResources().getString(Strings.sun_title)} isSelected={false} context={this.getContext()}/>
                     <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.mon)} onRepeatClick={this.onRepeatClick} title={this.getUIProps().context.getResources().getString(Strings.mon_title)} isSelected={false} context={this.getContext()}/>
                     <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.tue)} onRepeatClick={this.onRepeatClick} title={this.getUIProps().context.getResources().getString(Strings.tue_title)} isSelected={false} context={this.getContext()}/>
                     <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.wed)} onRepeatClick={this.onRepeatClick} title={this.getUIProps().context.getResources().getString(Strings.wed_title)} isSelected={false} context={this.getContext()}/>
                     <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.thu)} onRepeatClick={this.onRepeatClick} title={this.getUIProps().context.getResources().getString(Strings.thu_title)} isSelected={false} context={this.getContext()}/>
                     <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.fri)} onRepeatClick={this.onRepeatClick} title={this.getUIProps().context.getResources().getString(Strings.fri_title)} isSelected={false} context={this.getContext()}/>
                     <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.sat)} onRepeatClick={this.onRepeatClick} title={this.getUIProps().context.getResources().getString(Strings.sat_title)} isSelected={false} context={this.getContext()}/>

                </div>
            </>  
        );
    }
     
    private getRepeatCSS(cssStyle:TimeSettingsCSSStyle)
    {
        return(
            // <div style={cssStyle.getRepeatDivCSSStyle()}>                              
              <> 
                <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.none)} onRepeatClick={(id: string, isSelected: boolean) =>{(this.getUIComponentHandler() as TimeSettingsComponentHandler).onRepeatIntervalSelected(id);}}  title={this.getUIProps().context.getResources().getString(Strings.none_title)} isSelected={(this.getUIState() as TimeSettingsComponentState).repeatInterval === this.getContext().getResources().getString(Strings.none)} context={this.getContext()}/>
                <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.monthly)} onRepeatClick={(id: string, isSelected: boolean) =>{(this.getUIComponentHandler() as TimeSettingsComponentHandler).onRepeatIntervalSelected(id);}} title={this.getUIProps().context.getResources().getString(Strings.monthly_title)} isSelected={(this.getUIState() as TimeSettingsComponentState).repeatInterval === this.getContext().getResources().getString(Strings.monthly)} context={this.getContext()}/>
                <RepeatCardSettingComponent id={this.getUIProps().context.getResources().getString(Strings.yearly)} onRepeatClick={(id: string, isSelected: boolean) =>{(this.getUIComponentHandler() as TimeSettingsComponentHandler).onRepeatIntervalSelected(id);}} title={this.getUIProps().context.getResources().getString(Strings.yearly_title)} isSelected={(this.getUIState() as TimeSettingsComponentState).repeatInterval === this.getContext().getResources().getString(Strings.yearly)} context={this.getContext()}/>

            </>
        );
    }

    private getSelectTimeCSS(cssStyle: TimeSettingsCSSStyle, state: TimeSettingsComponentState)
    {
        return (

        <>
             <div id="time-settings-select-starttime-main">
                <label id="time-settings-header-title" style={cssStyle.getTimeHeaderCSSStyle()}>{this.getUIProps().context.getResources().getString(Strings.start_time)}</label><br/>
               <TimePickerComponent ref={(item: any) => {this.selectTimeFromDateRef = item;}} onChange={(time: any)=>{}} onKeyPress={()=>("")} label={""} format={"HH:mm"} id={"Time"} placeholder={""} isRequired={true} isDisabled={false} value={moment(new Date(),'hh:mm')} inputType={""} context={this.getUIProps().context} emptyErrorMsg={""}/>
            </div>
            <div id="time-settings-select-endtime-main">
                <label id="time-settings-header-title" style={cssStyle.getTimeHeaderCSSStyle()}>{this.getUIProps().context.getResources().getString(Strings.end_time)}</label><br/>
               <TimePickerComponent ref={(item: any) => {this.selectTimeToDateRef = item;}} onChange={(time: any)=>{}} onKeyPress={()=>("")} label={""} format={"HH:mm"} id={"Time"} placeholder={""} isRequired={true} isDisabled={false} value={moment(new Date(),'hh:mm')} inputType={""} context={this.getUIProps().context} emptyErrorMsg={""}/>
            </div>
        </>);
      
    }

    private getSelectDateTimeCSS(cssStyle: TimeSettingsCSSStyle, state: TimeSettingsComponentState)
    {
        return (

       <>
       <div id="time-settings-select-startdatetime-main" >
           <label id="time-settings-header-title" style={cssStyle.getTimeHeaderCSSStyle()}>{this.getUIProps().context.getResources().getString(Strings.start_date)}</label><br/>
           <DateTimePickerComponent ref={(item: any) => {this.selectFromDateTimeRef = item;}} onChange={(time: any)=>{}} onKeyPress={()=>("")} label={""} format={"DD/MM/yyyy HH:mm"} id={"DateTime"} placeholder={""} isRequired={true} isDisabled={false} value={new Date()} inputType={""} context={this.getUIProps().context} emptyErrorMsg={""}/>
       </div>
       <div id="time-settings-select-enddatetime-main" >
           <label id="time-settings-header-title" style={cssStyle.getTimeHeaderCSSStyle()}>{this.getUIProps().context.getResources().getString(Strings.end_date)}</label><br/>
           <DateTimePickerComponent ref={(item: any) => {this.selectToDateTimeRef = item;}} onChange={(time: any)=>{}} onKeyPress={()=>("")} label={""} format={"DD/MM/yyyy HH:mm"} id={"DateTime"} placeholder={""} isRequired={true} isDisabled={false} value={new Date()} inputType={""} context={this.getUIProps().context} emptyErrorMsg={""}/>
       </div>
   </>);
    }

    private onSelected(isSelected: boolean, callerSetting: string)
    {
        (this.getUIComponentHandler() as TimeSettingsComponentHandler).onTimeSettingSelected(callerSetting);
    }

    private onRepeatClick(id: string, isSelected: boolean):void
    {
        console.log("onRepeat Clicked: " + id);
        if(isSelected)
        {
            this.weeklyIntervalList.push(id); 
        }
        else
        {
            this.weeklyIntervalList = this.weeklyIntervalList.filter((weeklyId: string) =>
            {
                return id !== weeklyId;
            });
        }
    }

     private getStartDuration(fromDate:string, toDate:string):number
    {
        var admission = moment(fromDate, 'DD-MM-YYYY'); 
        var discharge = moment(toDate, 'DD-MM-YYYY');
        var days = discharge.diff(admission, 'days');   
        console.log("getStartDuration() invoked:",fromDate +"days:"+days);

        return days;
    }

    private getEndDuration(fromDate:string, toDate:string):number
    {
        var admission = moment(toDate, 'DD-MM-YYYY'); 
        var discharge = moment(fromDate, 'DD-MM-YYYY');
        var days = discharge.diff(admission, 'days');   
        console.log("getEndDuration() invoked:",toDate+"days:"+days);

        
        return days;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/timesettings/timesettingsview.tsx